import ElasticSearch from 'elasticsearch';

import globalConfig from '../config';

const currentHost = globalConfig.elasticSearch;

const getElasticClient = function() {
  return new ElasticSearch.Client({
    host: currentHost,
    requestTimeout: 15000
  });
};

const indexShop = 'ecb_shops';
const indexProduct = 'ecb_products';
const indexOrder = 'ecb_orders';
const indexReview = 'ecb_reviews';
const indexQuestion = 'ecb_questions';
const indexAnswer = 'ecb_answers';

export { getElasticClient, indexShop, indexProduct, indexOrder, indexReview, indexQuestion, indexAnswer };
